import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

type TPayload = {
  uuid: string | null;
  receivedDate: string | null;
  email: string | null;
  confirmationPdfUrl: string | null;
};

export const setTerminateDetails = (state: Draft<IPaymentState>, { payload }: PayloadAction<TPayload>) => {
  state.terminateDetails = {
    uuid: payload.uuid,
    receivedDate: payload.receivedDate,
    email: payload.email,
    confirmationPdfUrl: payload.confirmationPdfUrl,
  };
  state.updatedAt = Date.now();
};
